import navigationData from './navigationData';
import NavBarItem, {NavRoute} from './NavBarItem';
import List from '@mui/material/List';
import classNames from 'classnames';
import IconButton from '@mui/material/IconButton';
import {useCallback, useMemo, useState} from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import {useAppSelector} from '../../store/hooks';
import {Report} from '../reports/types';
import i18n from 'i18next';

const getReportsNavigation = (reports: Report[]): NavRoute[] => {
  const submenu = reports.map(({displayName, id}) => ({
    label: displayName,
    route: `/reports/${id}`,
    permissions: null
  }));

  return [{
    label: i18n.t('navigation:reports'),
    permissions: null,
    submenu
  }];
};

export const NavBar = () => {
  const {reports} = useAppSelector((state) => state.permissions);
  const [open, setOpen] = useState(false);

  const closeDrawer = useCallback(() => {
    setOpen(false);
  }, []);

  const openDrawer = useCallback(() => {
    setOpen(true);
  }, []);

  const reportsNavigation = useMemo(() => {
    return reports?.length ? getReportsNavigation(reports) : [];
  }, [reports]);

  return (
    <>
      <IconButton
        className={classNames('burger icon-button', {'active': open})}
        onClick={openDrawer}
      >
        <div />
        <div />
        <div />
      </IconButton>

      <SwipeableDrawer
        anchor="left"
        open={open}
        onClose={closeDrawer}
        onOpen={openDrawer}
        classes={{
          paper: 'navbar'
        }}
      >
        <List className="navbar__list">
          {[...navigationData, ...reportsNavigation].map((item) => (
            <NavBarItem {...item} key={item.label} closeDrawer={closeDrawer} />
          ))}
        </List>
      </SwipeableDrawer>
    </>
  );
};
